/**
 * @author yan st
 * @date 2022-08-30 13:51
 * @Description:
 */

export const adminhomeRouter = [
  {
    path: "",
    redirect: "index",
  },
  {
    path: "index",
    meta: {
      title: "首页",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/adminhome/page/index"),
  },
  {
    path: "declarelist",
    meta: {
      title: "申报列表",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/adminhome/page/declarelist"),
  },
  {
    path: "project/index",
    meta: {
      title: "项目月报列表",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/adminhome/page/project/index"),
  },
  {
    path: "project/detail",
    meta: {
      title: "项目月报详情",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/adminhome/page/project/detail"),
  },
  {
    path: "project_list/index",
    meta: {
      title: "中期评审资料",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/adminhome/page/project_list/index"),
  },
  {
    path: "end_project_list/detail",
    meta: {
      title: "结项评审资料详情",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/adminhome/page/end_project_list/detail"),
  },
  {
    path: "end_project_list/index",
    meta: {
      title: "结项评审资料",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/adminhome/page/end_project_list/index"),
  },
  {
    path: "supply_project_list/detail",
    meta: {
      title: "结项评审资料详情（补充）",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () =>
      import("../views/adminhome/page/supply_project_list/detail"),
  },
  {
    path: "supply_project_list/index",
    meta: {
      title: "结项评审资料（补充）",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () =>
      import("../views/adminhome/page/supply_project_list/index"),
  },
  {
    path: "project_list/detail",
    meta: {
      title: "中期评审资料详情",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/adminhome/page/project_list/detail"),
  },
  {
    path: "cdeclarelist",
    meta: {
      title: "初审列表",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/adminhome/page/cdeclarelist"),
  },
  {
    path: "fdeclarelist",
    meta: {
      title: "复审列表",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/adminhome/page/fdeclarelist"),
  },
  {
    path: "declaredetail",
    meta: {
      title: "申报详情",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/adminhome/page/declaredetail"),
  },
  {
    path: "cdeclaredetail",
    meta: {
      title: "申报详情",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/adminhome/page/cdeclaredetail"),
  },
  {
    path: "fdeclaredetail",
    meta: {
      title: "申报详情",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/adminhome/page/fdeclaredetail"),
  },
  {
    path: "auditRecords",
    meta: {
      title: "审核记录",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/adminhome/page/auditRecords"),
  },
  {
    path: "scoreRecords",
    meta: {
      title: "评分记录",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/adminhome/page/scoreRecords"),
  },
  {
    path: "orglist",
    meta: {
      title: "机构列表",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/adminhome/page/orglist"),
  },
  {
    path: "expertlist",
    meta: {
      title: "专家列表",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/adminhome/page/expertlist"),
  },
  {
    path: "performance",
    meta: {
      title: "绩效管理",
      needLogin: true,
    },
    component: () => import("../views/adminhome/page/performance/index"),
  },
  {
    path: "performance/detail",
    meta: {
      title: "指标配置",
      needLogin: true,
    },
    component: () => import("../views/adminhome/page/performance/detail"),
  },
  {
    path: "report",
    meta: {
      title: "月报管理",
      needLogin: true,
    },
    component: () => import("../views/adminhome/page/report/index"),
  },
  {
    path: "report/detail",
    meta: {
      title: "月报详情",
      needLogin: true,
    },
    component: () => import("../views/adminhome/page/report/detail"),
  },
  {
    path: "loglist",
    meta: {
      title: "日志列表",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/adminhome/page/loglist"),
  },
  {
    path: "pass",
    meta: {
      title: "修改密码",
      needLogin: true, // 是否需要登录才能访问
    },
    component: () => import("../views/adminhome/page/pass"),
  },
];

export default adminhomeRouter;
